import { createContext, useContext } from 'react';

export const QuizReviewContext = createContext(null);
export const useQuizReview = () => useContext(QuizReviewContext);
